import { render, staticRenderFns } from "./ProjectionsPlayground.vue?vue&type=template&id=4b2dbf5a&scoped=true&"
import script from "./ProjectionsPlayground.vue?vue&type=script&lang=js&"
export * from "./ProjectionsPlayground.vue?vue&type=script&lang=js&"
import style0 from "./ProjectionsPlayground.vue?vue&type=style&index=0&id=4b2dbf5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2dbf5a",
  null
  
)

export default component.exports